import { TrustBoxCarousel } from './trustpilot-widget/TrustBoxCarousel';
import { TrustBoxMicroReviewCount } from './trustpilot-widget/TrustBoxMicroReviewCount';
import { TrustBoxMini } from './trustpilot-widget/TrustBoxMini';
import { TrustBoxProps } from './trustpilot-widget/types';

export const TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

export enum TrustpilotWidgetType {
  TRUSTBOX_MINI = 'TRUSTBOX_MINI',
  TRUSTBOX_CAROUSEL = 'TRUSTBOX_CAROUSEL',
  TRUSTBOX_MICRO_REVIEW_COUNT = 'TRUSTBOX_MICRO_REVIEW_COUNT',
}

export const TRUSTPILOT_WIDGET_TEMPLATE_ID: Record<TrustpilotWidgetType, string> = {
  [TrustpilotWidgetType.TRUSTBOX_CAROUSEL]: '53aa8912dec7e10d38f59f36',
  [TrustpilotWidgetType.TRUSTBOX_MINI]: '53aa8807dec7e10d38f59f32',
  [TrustpilotWidgetType.TRUSTBOX_MICRO_REVIEW_COUNT]: '5419b6a8b0d04a076446a9ad',
};

export const TRUSTPILOT_WIDGET_SCRIPT_TAG_ID: Record<TrustpilotWidgetType, string> = {
  [TrustpilotWidgetType.TRUSTBOX_CAROUSEL]: 'trustpilot-carousel-reviews',
  [TrustpilotWidgetType.TRUSTBOX_MINI]: 'trustbox-mini',
  [TrustpilotWidgetType.TRUSTBOX_MICRO_REVIEW_COUNT]: 'trustpilot-microscore-review',
};

export const TRUSTPILOT_WIDGET_COMPONENT: Record<TrustpilotWidgetType, React.FC<TrustBoxProps>> = {
  [TrustpilotWidgetType.TRUSTBOX_CAROUSEL]: TrustBoxCarousel,
  [TrustpilotWidgetType.TRUSTBOX_MINI]: TrustBoxMini,
  [TrustpilotWidgetType.TRUSTBOX_MICRO_REVIEW_COUNT]: TrustBoxMicroReviewCount,
};
